export default __webpack_public_path__ + "fr/static/media/paypal-payment.f942c76d.png";